export default {
  current: 'Current',
  noActiveRecipe: 'No active recipe on this furnace.',
};
